import React, { ReactElement, useContext } from 'react';
import { DepartmentInterface } from '../../../../modules/departments/interfaces/department.interface';
import Link from 'atomic/utilization/link';
import { TeApiContext } from '@ecommerce/nest-ssr/common';

import './category-list.scss';

interface CategoryListProps {
    isOpenMenu: boolean;
    onClose: () => void;
    departments: DepartmentInterface[];
}

const CategoryList: React.FC<CategoryListProps> = (props): ReactElement => {
    const api = useContext(TeApiContext);

    if (api === null) {
        throw new Error('Invalid API context');
    }

    return (
        <div
            className={`category-list ${props.isOpenMenu ? 'category-list--visible' : ''}
                category-list--${api.getDevice() === 'desktop' ? 'desktop' : 'mobile'}`}
        >
            <div className="category-list__wrapper">
                <div className="category-list__item">
                    { api.getDevice() === 'desktop'
                        ? (
                            <span className="category-list__close" tabIndex={0} role="button"
                                onClick={props.onClose}
                            >
                                <i className="icon-close"/>
                            </span>
                        )
                        : (
                            <div className="category-list__title">
                                Wszystkie kategorie:
                            </div>
                        )}
                    { props.departments.map(department => (
                        <Link
                            href={department.url}
                            key={department.name}
                            title={department.name}
                            className={api.getDevice() === 'desktop' ? 'desktop' : 'mobile'}
                        >
                            <i className={`dep-${department.id}`}/>
                            {department.name}
                        </Link>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default CategoryList;
